import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerApi, PartnerDTO } from '@lkp/parking-sdk';
import { Store } from '@ngxs/store';
import { delay, Subject, takeUntil } from 'rxjs';
import { PARTNER_API } from 'src/app/core/providers/api.module';
import { SetCurrentPartner } from 'src/app/core/states/partner/partner.action';
import { OrdersState } from 'src/app/core/states/orders/orders.state';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {
  private admin = false;
  private partnersRequested = false;

  @Input()
  set isAdmin(isAdmin: boolean | undefined) {
    this.admin = !!isAdmin;
    if (this.admin) {
      this.loadPartners();
    }
  }

  get isAdmin() {
    return this.admin;
  }

  description: string = '';
  isProd = true;
  activeOrder = false;
  partners?: PartnerDTO[];
  partnerIsActiveNow = false;
  readonly onDestroy$ = new Subject<void>();

  @Output() openSearchDrawer = new EventEmitter<void>();
  @Output() openRegisterDrawer = new EventEmitter<void>();

  constructor(
    @Inject(PARTNER_API) private readonly partnerApi: PartnerApi,
    private readonly store: Store,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.description = environment.description;
    this.isProd = environment.isProd;

    this.store
      .select(OrdersState.order)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((order) => {
        this.activeOrder = !!order?.orderId;
      });
  }

  setCurrentPartner(partner: PartnerDTO) {
    if (partner) {
      this.partnerIsActiveNow = true;
      this.store
        .dispatch(new SetCurrentPartner(partner))
        .pipe(takeUntil(this.onDestroy$), delay(0))
        .subscribe(() => {
          this.router.navigate(['/partnerportalen/']);
        });
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private loadPartners() {
    if (this.partnersRequested) {
      return;
    }

    this.partnersRequested = true;
    this.partnerApi
      .findPartners()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((partners) => {
        this.partners = partners;
      });
  }
}
